// extracted by mini-css-extract-plugin
export default {"styled_table":"Notifications_styled_table__BEOdu","active-row":"Notifications_active-row__5vOas"};